import { createFrontendFeatureLoader } from '@backstage/frontend-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import techInsightsPlugin from '@backstage-community/plugin-tech-insights/alpha';
import grafanaPlugin from '@backstage-community/plugin-grafana/alpha';
import platformCapabilitiesPlugin from '@clrslate/backstage-plugin-platform-capabilities/alpha';
import operatingModelPlugin from '@clrslate/backstage-plugin-operating-model/alpha';
import { clrslateThemeModule } from '@clrslate/backstage-theme';
import { authModule } from './modules/auth';
import { navModule } from './modules/nav';
import { reliabilityDiscoveryModule } from './modules/reliabilityDiscovery';
import {
  componentGovernanceModule,
  componentGovernancePlugin,
} from './modules/componentGovernance';
import { governanceCatalogPlugin } from './modules/componentGovernance/catalogOverride';
import { gcpTechInsightsPlugin } from './modules/scorecards';

export default createApp({
  features: [
    createFrontendFeatureLoader({
      loader({ config }) {
        if (config.getOptionalString('clrslate.profile') === 'gcp') {
          return [
            operatingModelPlugin,
            gcpTechInsightsPlugin,
            authModule,
            navModule,
            clrslateThemeModule,
          ];
        }
        return [
          governanceCatalogPlugin,
          platformCapabilitiesPlugin,
          operatingModelPlugin,
          techInsightsPlugin,
          grafanaPlugin,
          authModule,
          navModule,
          reliabilityDiscoveryModule,
          componentGovernanceModule,
          componentGovernancePlugin,
          clrslateThemeModule,
        ];
      },
    }),
  ],
});
